var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbUp = function SvgThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M8.58 11.055 3.25 10.8h-1.17A1.335 1.335 0 0 1 .746 9.469v-4.2H3.11l4.125-3.99a1.264 1.264 0 0 1 2.118.93q.002.27-.037.54a7 7 0 0 1-.694 1.744l-.049.105h1.302a1.29 1.29 0 0 1 1.023.442 1.9 1.9 0 0 1 .308 1.586v.045l-.923 3c-.307.919-.873 1.384-1.702 1.384m-4.946-.986 4.965.236c.33 0 .716-.105.96-.862l.915-3a1.2 1.2 0 0 0-.147-.95.54.54 0 0 0-.446-.175H7.354l.603-1.197c.27-.471.478-.975.62-1.5q.03-.217.03-.435a.514.514 0 0 0-.856-.375L3.626 5.786zm-2.138-4.05v3.45a.585.585 0 0 0 .585.581h.803V6.019z"
  })));
};
export default SvgThumbUp;